import React, { useEffect, useState } from "react";

import kv01 from "../../assets/kv01.png";
import kv01mobile from "../../assets/kv01mobile.png";
import { BannerContainer, BannerImage } from "./styles";

export const HeaderBannerHome = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <BannerContainer>
      <BannerImage src={isMobile ? kv01mobile : kv01} alt="Banner" />
    </BannerContainer>
  );
};
export default HeaderBannerHome;
